import { encode } from 'utils/crypto/crypto';
import { AAMALI_PLUS_ACCOUNT_CATEGORY } from 'views/Numbers/constants';

export const numberDetailsPath = (
	accountNumber: string,
	billingAccountId: string,
	accountType: string,
	billingType: string,
	upAccountId: string,
	isAamaliPlus?: boolean,
	accountCategory?: string
): string => {
	if (isAamaliPlus && accountCategory) {
		return `/dashboard/numbers/${encode(
			accountNumber
		)}/${billingAccountId}/${accountType}/${billingType}/${upAccountId}/aamali-services?accountCategory=${AAMALI_PLUS_ACCOUNT_CATEGORY}`

	}
	return `/dashboard/numbers/${encode(
		accountNumber
	)}/${billingAccountId}/${accountType}/${billingType}/${upAccountId}`;
};
